import { useEffect, useMemo, useState } from 'react';
import { setModelsModalState, useModelsModalState } from '../../../../../store/state';
import { useAsyncEffect } from 'ahooks';
import { v4 } from 'uuid';
import { request } from '@shakkerai/services';
import { innerMoreType, modelTypeMap } from '../../../../../constants';
import { useTempState } from '@starflow/app/store';

export const pageSize = 30;

export const useCateListFetch = (level, target, modelType, menuPath) => {
  const [loading, setLoading] = useState(false);
  const catesModels = useModelsModalState('catesModels');
  const combinedTagCode = useModelsModalState('combinedTagCode');
  const baseTypes = useModelsModalState('baseTypes');
  const globalMode = useTempState('globalMode');
  const combinedTagCodes = useMemo(() => {
    if (level === 2) {
      return {
        isCombine: false,
        codeStr: '',
      };
    }
    const target = menuPath.menu.children.find((child) => child.choosed);
    const str = Object.values(combinedTagCode)
      .filter((t) => t)
      .join(',');
    return {
      isCombine: str.length > 1,
      codeStr: str.length > 1 ? `${target.code},${str}` : `${target.code}`,
    };
  }, [combinedTagCode, menuPath.menu]);

  const fetchCollect = async (params) => {
    try {
      const res = await request('/api/canva/model/collection', params);
      if (res.code === 0) {
        return {
          id: params.collectionId,
          type: innerMoreType.collect,
          list: res.data.data,
          total: res.data.total,
          title: '精选推荐',
        };
      } else {
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  };
  const fetchList = async (params, child) => {
    try {
      const res = await request('/api/www/model/tool/baseSearch', params);
      if (res.code === 0) {
        return {
          id: params.tagCode,
          type: innerMoreType.children,
          list: res.data.data,
          total: res.data.total,
          page: 1,
          title: child.tagLabel,
          requestId: params.requestId,
        };
      } else {
        console.log('接口异常');
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  // 列表数据是根据是否有合集以及children来共同决定
  useAsyncEffect(async () => {
    // const key = `${menuPath?.level}-${target.code}`; // 3级数据缓存不了，因为menuPath没有被记录
    // const tg = catesModels[key];
    // if (tg) return; // 二级缓存不了，设计bug TODO
    if (!target) return;
    setLoading(true);

    const collectionId = target.collectionId;
    let cateList = [];

    const getLists = async (child) => {
      return await fetchList(
        {
          modelType: modelTypeMap[modelType],
          page: 1,
          pageSize: pageSize,
          requestId: v4(),
          baseTypes: globalMode === 'pro' ? baseTypes : ['19'],
          tagCode: child.code,
          combinedTagCodes: combinedTagCodes.isCombine ? combinedTagCodes.codeStr : undefined,
        },
        child,
      );
    };

    // 获取数据
    if (collectionId) {
      const getCollect = async (id) => {
        const res = await fetchCollect({
          page: 1,
          pageSize: 30,
          collectionId: id,
          requestId: v4(),
        });
        return res;
      };
      cateList = await Promise.all([getCollect(collectionId), getLists(target)]);
    } else {
      const res = await getLists(target);
      cateList.push(res);
    }
    setModelsModalState({
      catesModels: {
        ...catesModels,
        [`${level}-${target.code}`]: cateList, // key这样拼接是防code重复
      },
    });
    setLoading(false);
  }, [target, baseTypes, combinedTagCodes]);
  return { loading, fetchList };
};
